import {ShareLandLogoLink} from '#/components/header/share-land-logo-link';
import {ReactComponent as LogoMetamask} from '#/components/icons/logo-metamask.svg';
import {HeaderContentLayout} from '#/components/layout/layout';
import {Page} from '#/pages/page';
import {DefaultChildren} from '#/utils/utils';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

const MetamaskCannotReconnectPage: FunctionComponent<DefaultChildren> = () => {
  const {t} = useTranslation('translation');

  return (
    <Page title={t('pages.metamaskCouldntReconnect.htmlTitle')}>
      <HeaderContentLayout className='bg-black'>
        <Header />
        <div className='bg-black overflow-y-scroll flex-center p-8'>
          <div className='flex flex-col items-center gap-4 sm:gap-10 '>
            <LogoMetamask className={'w-16 h-16'} />
            <div className='text-white text-xl sm:text-3xl font-bold text-center'>
              <span className='block'>{t('pages.metamaskCouldntReconnect.explanation.title')}</span>
              <span className='block'>{t('pages.metamaskCouldntReconnect.explanation.pleaseReload')}</span>
            </div>

            <ReloadButton />
          </div>
        </div>
      </HeaderContentLayout>
    </Page>
  );
};

const ReloadButton: FunctionComponent = () => {
  const {t} = useTranslation('translation');

  return (
    <button
      className='text-base sm:text-xl bg-deepblue p-3 text-white font-bold rounded-xl mt-3 sm:mt-6 hover:opacity-70 transition-opacity'
      onClick={() => {
        window.location.reload();
      }}
    >
      {t('actions.reload')}
    </button>
  );
};

const Header: FunctionComponent = () => {
  return (
    <header className={'h-header w-full bg-black px-5 py-3'}>
      <div className='w-full h-full flex justify-between items-center gap-4 mx-auto'>
        <div className='grow flex h-full items-center'>
          <div className='w-[24px]' />
          <ShareLandLogoLink />
        </div>
      </div>
    </header>
  );
};

export {MetamaskCannotReconnectPage};
